import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/marketing/SEOHead';
import CTASection from '@/components/marketing/CTASection';

export default function NotFound() {
  return (
    <>
      <SEOHead title="Page Not Found" description="The page you are looking for does not exist on Ads Dashbound." path="/404" />
      <section className="bg-[#07111F] text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
          <span className="font-display text-6xl sm:text-7xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#7C3AED]">404</span>
          <h1 className="font-display mt-4 text-3xl sm:text-4xl font-bold">Page not found</h1>
          <p className="mt-3 text-slate-400">The page you’re looking for doesn’t exist or has moved.</p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold transition-colors">Back to homepage</Link>
            <Link to="/contact" className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/15 text-white font-semibold transition-colors">Contact support</Link>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
